import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ActivationCode = {
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Adventure = {
  image?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
  txHash: Scalars['String']['output'];
  type: AdventureType;
};

export enum AdventureType {
  Beach = 'beach',
  Christmas = 'christmas',
  City = 'city',
  Forest = 'forest',
  Holloween = 'holloween',
  None = 'none',
  Space = 'space'
}

export type ChainAsset = {
  community_id: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  logo_url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  usd_value: Scalars['Float']['output'];
};

export type Chat = {
  adventureType: AdventureType;
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lazbubuMasterName?: Maybe<Scalars['String']['output']>;
  lazbubuName?: Maybe<Scalars['String']['output']>;
  role: ChatRole;
  score?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['Int']['output'];
  tokenId: Scalars['Int']['output'];
  type: ChatType;
  userAddress: Scalars['String']['output'];
};

export enum ChatRole {
  Lazbubu = 'lazbubu',
  Master = 'master'
}

export type ChatSimple = {
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  role: ChatRole;
  score?: Maybe<Scalars['Int']['output']>;
  tokenId: Scalars['Int']['output'];
  type: ChatType;
  userAddress: Scalars['String']['output'];
};

export enum ChatType {
  Action = 'action',
  AdventureChoose = 'adventure_choose',
  AdventurePrompt = 'adventure_prompt',
  AdventureReward = 'adventure_reward',
  Normal = 'normal',
  UpdateDat = 'update_dat',
  Welcome = 'welcome'
}

export type Config = {
  avatarBaseUrl: Scalars['String']['output'];
  contracts: Contracts;
  rsaPublicKey: Scalars['String']['output'];
};

export type Contracts = {
  dataAnchoringTokenAddress: Scalars['String']['output'];
  dataRegistryAddress: Scalars['String']['output'];
  inferenceAddress: Scalars['String']['output'];
  settlementAddress: Scalars['String']['output'];
  trainingAddress: Scalars['String']['output'];
  verifiedComputingAddress: Scalars['String']['output'];
};

export type Lazbubu = {
  adventureCount?: Maybe<Scalars['Int']['output']>;
  birthday: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  masterName: Scalars['String']['output'];
  mature: Scalars['Boolean']['output'];
  memoryUnitQuota?: Maybe<Scalars['Int']['output']>;
  memoryUnitUsed?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  needSetNames: Scalars['Boolean']['output'];
  personality?: Maybe<Scalars['String']['output']>;
  rarity: Scalars['Int']['output'];
  tokenId: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type Memory = {
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
  tokenId: Scalars['Int']['output'];
};

export type MessageQuota = {
  availableQuota: Scalars['Int']['output'];
  claimed: Scalars['Boolean']['output'];
  dailyMessageQuota: Scalars['Int']['output'];
  giftboxMessageQuota: Scalars['Int']['output'];
  lastTimeMessageQuotaClaimed: Scalars['Int']['output'];
  resetTime: Scalars['Int']['output'];
  todayMessageCount: Scalars['Int']['output'];
  totalMessageQuota: Scalars['Int']['output'];
};

export type Mutation = {
  addMintWhitelist: Scalars['Boolean']['output'];
  chat: Chat;
  generateChatImage?: Maybe<ShareImage>;
  proof: Scalars['String']['output'];
  reedemAcitvationCode: Scalars['Boolean']['output'];
  removeMintWhitelist: Scalars['Boolean']['output'];
  setNames: Scalars['String']['output'];
  syncLevel: Scalars['Boolean']['output'];
  uploadFile: Scalars['String']['output'];
};


export type MutationAddMintWhitelistArgs = {
  addresses: Scalars['String']['input'];
};


export type MutationChatArgs = {
  content: Scalars['String']['input'];
  tokenId: Scalars['Int']['input'];
};


export type MutationGenerateChatImageArgs = {
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationProofArgs = {
  proofRequest: Scalars['String']['input'];
};


export type MutationReedemAcitvationCodeArgs = {
  activationCode: Scalars['String']['input'];
};


export type MutationRemoveMintWhitelistArgs = {
  addresses: Scalars['String']['input'];
};


export type MutationSetNamesArgs = {
  masterName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationSyncLevelArgs = {
  tokenId: Scalars['Int']['input'];
};


export type MutationUploadFileArgs = {
  data: Scalars['String']['input'];
};

export type Permit = {
  /** permit data */
  data?: Maybe<Scalars['String']['output']>;
  /** error message */
  err?: Maybe<Scalars['String']['output']>;
  /** permit JSON string */
  permit?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  adventurePermit: Permit;
  adventures: Array<Adventure>;
  airdropLazbubuCreated?: Maybe<Scalars['Int']['output']>;
  airdropLazbubuData: Scalars['String']['output'];
  chats: Array<Chat>;
  config: Config;
  countTodayAirdrop: Scalars['Int']['output'];
  createMemoryPermit: Permit;
  getChatsByShareId?: Maybe<Array<Maybe<ChatSimple>>>;
  getUserActivationCodes?: Maybe<Array<ActivationCode>>;
  giftLazbubuCreated?: Maybe<Scalars['Int']['output']>;
  giftLazbubuData: Scalars['String']['output'];
  isMintWhitelisted: Scalars['Boolean']['output'];
  lazbubu: Lazbubu;
  lazbubuCreated?: Maybe<Scalars['Int']['output']>;
  lazbubuData: Scalars['String']['output'];
  lazbubuList: Array<Lazbubu>;
  lostLazbubuList: Array<Lazbubu>;
  maxUsdAsset: ChainAsset;
  me: User;
  memories: Array<Memory>;
  memoryAvailable: Scalars['Boolean']['output'];
  messageQuota: MessageQuota;
  mintPermit: Permit;
  mintWhitelist: Scalars['String']['output'];
  personalityAvailable: Scalars['Boolean']['output'];
  setLevelPermit: Permit;
  setPersonalityPermit: Permit;
};


export type QueryAdventurePermitArgs = {
  adventureType: AdventureType;
  tokenId: Scalars['Int']['input'];
};


export type QueryAdventuresArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  tokenId: Scalars['Int']['input'];
};


export type QueryChatsArgs = {
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  tokenId: Scalars['Int']['input'];
};


export type QueryCreateMemoryPermitArgs = {
  tokenId: Scalars['Int']['input'];
};


export type QueryGetChatsByShareIdArgs = {
  shareId: Scalars['String']['input'];
};


export type QueryIsMintWhitelistedArgs = {
  address: Scalars['String']['input'];
};


export type QueryLazbubuArgs = {
  tokenId: Scalars['Int']['input'];
};


export type QueryLazbubuDataArgs = {
  activationCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLazbubuListArgs = {
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLostLazbubuListArgs = {
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMemoriesArgs = {
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  tokenId: Scalars['Int']['input'];
};


export type QueryMemoryAvailableArgs = {
  tokenId: Scalars['Int']['input'];
};


export type QueryMessageQuotaArgs = {
  tokenId: Scalars['Int']['input'];
};


export type QueryMintPermitArgs = {
  avatar?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPersonalityAvailableArgs = {
  tokenId: Scalars['Int']['input'];
};


export type QuerySetLevelPermitArgs = {
  tokenId: Scalars['Int']['input'];
};


export type QuerySetPersonalityPermitArgs = {
  tokenId: Scalars['Int']['input'];
};

export type ShareImage = {
  imageUrl?: Maybe<Scalars['String']['output']>;
  shareId: Scalars['String']['output'];
};

export type User = {
  userAddress: Scalars['String']['output'];
};

export type AdventurePermitQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
  adventureType: AdventureType;
}>;


export type AdventurePermitQuery = { adventurePermit: { permit?: string, data?: string, err?: string } };

export type AdventuresQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdventuresQuery = { adventures: Array<{ type: AdventureType, timestamp: number, txHash: string, text: string, image?: string, score?: number }> };

export type AirdropInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type AirdropInfoQuery = { airdropLazbubuCreated?: number, airdropLazbubuData: string };

export type ChatMutationVariables = Exact<{
  tokenId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
}>;


export type ChatMutation = { chat: { id: number, tokenId: number, lazbubuName?: string, lazbubuMasterName?: string, userAddress: string, role: ChatRole, adventureType: AdventureType, type: ChatType, content: string, timestamp: number, image?: string, score?: number } };

export type ChatsQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatsQuery = { chats: Array<{ id: number, tokenId: number, lazbubuName?: string, lazbubuMasterName?: string, userAddress: string, role: ChatRole, adventureType: AdventureType, type: ChatType, content: string, timestamp: number, image?: string, score?: number }> };

export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = { config: { avatarBaseUrl: string, contracts: { dataRegistryAddress: string, dataAnchoringTokenAddress: string, verifiedComputingAddress: string } } };

export type CountTodayAirdropQueryVariables = Exact<{ [key: string]: never; }>;


export type CountTodayAirdropQuery = { countTodayAirdrop: number };

export type SetNamesMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  masterName: Scalars['String']['input'];
}>;


export type SetNamesMutation = { setNames: string };

export type CreateMemoryPermitQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type CreateMemoryPermitQuery = { createMemoryPermit: { permit?: string, data?: string, err?: string } };

export type GenerateChatImageMutationVariables = Exact<{
  chatIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GenerateChatImageMutation = { generateChatImage?: { imageUrl?: string, shareId: string } };

export type GetChatsByShareIdQueryVariables = Exact<{
  shareId: Scalars['String']['input'];
}>;


export type GetChatsByShareIdQuery = { getChatsByShareId?: Array<{ id: number, tokenId: number, userAddress: string, role: ChatRole, type: ChatType, content: string, createdAt: string, image?: string, score?: number }> };

export type GetUserActivationCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserActivationCodesQuery = { getUserActivationCodes?: Array<{ id: string, code: string, status: string }> };

export type LazbubuQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type LazbubuQuery = { lazbubu: { tokenId: number, uuid: string, image: string, name: string, masterName: string, birthday: number, mature: boolean, adventureCount?: number, rarity: number, memoryUnitQuota?: number, memoryUnitUsed?: number, needSetNames: boolean, personality?: string } };

export type UserLazbubuInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserLazbubuInfoQuery = { giftLazbubuData: string, lazbubuData: string, giftLazbubuCreated?: number, lazbubuCreated?: number };

export type LazbubuDataQueryVariables = Exact<{
  activationCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type LazbubuDataQuery = { lazbubuData: string };

export type LazbubuFieldsFragment = { tokenId: number, uuid: string, image: string, name: string, masterName: string, birthday: number, mature: boolean, adventureCount?: number, rarity: number, memoryUnitQuota?: number, memoryUnitUsed?: number, needSetNames: boolean, personality?: string };

export type LazbubuListQueryVariables = Exact<{ [key: string]: never; }>;


export type LazbubuListQuery = { lazbubuList: Array<{ tokenId: number, uuid: string, image: string, name: string, masterName: string, birthday: number, mature: boolean, adventureCount?: number, rarity: number, memoryUnitQuota?: number, memoryUnitUsed?: number, needSetNames: boolean, personality?: string }> };

export type LostLazbubuListQueryVariables = Exact<{ [key: string]: never; }>;


export type LostLazbubuListQuery = { lostLazbubuList: Array<{ tokenId: number, uuid: string, image: string, name: string, masterName: string, birthday: number, mature: boolean, adventureCount?: number, rarity: number, memoryUnitQuota?: number, memoryUnitUsed?: number, needSetNames: boolean, personality?: string }> };

export type GetLazbubuListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLazbubuListQuery = { lazbubuList: Array<{ tokenId: number, uuid: string, image: string, name: string, masterName: string, birthday: number, mature: boolean, adventureCount?: number, rarity: number, memoryUnitQuota?: number, memoryUnitUsed?: number, needSetNames: boolean, personality?: string }>, lostLazbubuList: Array<{ tokenId: number, uuid: string, image: string, name: string, masterName: string, birthday: number, mature: boolean, adventureCount?: number, rarity: number, memoryUnitQuota?: number, memoryUnitUsed?: number, needSetNames: boolean, personality?: string }> };

export type MaxUsdAssetQueryVariables = Exact<{ [key: string]: never; }>;


export type MaxUsdAssetQuery = { maxUsdAsset: { id: string, community_id: number, name: string, logo_url: string, usd_value: number } };

export type MemoriesQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MemoriesQuery = { memories: Array<{ id: string, tokenId: number, content: string, timestamp: number }> };

export type MemoryAvailableQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type MemoryAvailableQuery = { memoryAvailable: boolean };

export type MessageQuotaQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type MessageQuotaQuery = { messageQuota: { claimed: boolean, availableQuota: number, dailyMessageQuota: number, giftboxMessageQuota: number, totalMessageQuota: number, resetTime: number, todayMessageCount: number } };

export type MintPermitQueryVariables = Exact<{ [key: string]: never; }>;


export type MintPermitQuery = { mintPermit: { permit?: string, data?: string, err?: string } };

export type PersonalityAvailableQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type PersonalityAvailableQuery = { personalityAvailable: boolean };

export type ProofMutationVariables = Exact<{
  proofRequest: Scalars['String']['input'];
}>;


export type ProofMutation = { proof: string };

export type ReedemAcitvationCodeMutationVariables = Exact<{
  activationCode: Scalars['String']['input'];
}>;


export type ReedemAcitvationCodeMutation = { reedemAcitvationCode: boolean };

export type SetLevelPermitQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type SetLevelPermitQuery = { setLevelPermit: { permit?: string, data?: string, err?: string } };

export type SetPersonalityPermitQueryVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type SetPersonalityPermitQuery = { setPersonalityPermit: { permit?: string, data?: string, err?: string } };

export type SyncLevelMutationVariables = Exact<{
  tokenId: Scalars['Int']['input'];
}>;


export type SyncLevelMutation = { syncLevel: boolean };

export type UploadFileMutationVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type UploadFileMutation = { uploadFile: string };

export const LazbubuFieldsFragmentDoc = gql`
    fragment LazbubuFields on Lazbubu {
  tokenId
  uuid
  image
  name
  masterName
  birthday
  mature
  adventureCount
  rarity
  memoryUnitQuota
  memoryUnitUsed
  needSetNames
  rarity
  tokenId
  uuid
  personality
}
    `;
export const AdventurePermitDocument = gql`
    query adventurePermit($tokenId: Int!, $adventureType: AdventureType!) {
  adventurePermit(tokenId: $tokenId, adventureType: $adventureType) {
    permit
    data
    err
  }
}
    `;
export const AdventuresDocument = gql`
    query adventures($tokenId: Int!, $pageNum: Int, $pageSize: Int, $date: String) {
  adventures(
    tokenId: $tokenId
    pageNum: $pageNum
    pageSize: $pageSize
    date: $date
  ) {
    type
    timestamp
    txHash
    text
    image
    score
  }
}
    `;
export const AirdropInfoDocument = gql`
    query airdropInfo {
  airdropLazbubuCreated
  airdropLazbubuData
}
    `;
export const ChatDocument = gql`
    mutation chat($tokenId: Int!, $content: String!) {
  chat(tokenId: $tokenId, content: $content) {
    id
    tokenId
    lazbubuName
    lazbubuMasterName
    userAddress
    role
    adventureType
    type
    content
    timestamp
    image
    score
  }
}
    `;
export const ChatsDocument = gql`
    query chats($tokenId: Int!, $pageNum: Int, $pageSize: Int) {
  chats(tokenId: $tokenId, pageNum: $pageNum, pageSize: $pageSize) {
    id
    tokenId
    lazbubuName
    lazbubuMasterName
    userAddress
    role
    adventureType
    type
    content
    timestamp
    image
    score
  }
}
    `;
export const ConfigDocument = gql`
    query config {
  config {
    contracts {
      dataRegistryAddress
      dataAnchoringTokenAddress
      verifiedComputingAddress
    }
    avatarBaseUrl
  }
}
    `;
export const CountTodayAirdropDocument = gql`
    query countTodayAirdrop {
  countTodayAirdrop
}
    `;
export const SetNamesDocument = gql`
    mutation setNames($uuid: String!, $name: String!, $masterName: String!) {
  setNames(uuid: $uuid, name: $name, masterName: $masterName)
}
    `;
export const CreateMemoryPermitDocument = gql`
    query createMemoryPermit($tokenId: Int!) {
  createMemoryPermit(tokenId: $tokenId) {
    permit
    data
    err
  }
}
    `;
export const GenerateChatImageDocument = gql`
    mutation generateChatImage($chatIds: [String!]) {
  generateChatImage(chatIds: $chatIds) {
    imageUrl
    shareId
  }
}
    `;
export const GetChatsByShareIdDocument = gql`
    query getChatsByShareId($shareId: String!) {
  getChatsByShareId(shareId: $shareId) {
    id
    tokenId
    userAddress
    role
    type
    content
    createdAt
    image
    score
  }
}
    `;
export const GetUserActivationCodesDocument = gql`
    query getUserActivationCodes {
  getUserActivationCodes {
    id
    code
    status
  }
}
    `;
export const LazbubuDocument = gql`
    query lazbubu($tokenId: Int!) {
  lazbubu(tokenId: $tokenId) {
    ...LazbubuFields
  }
}
    ${LazbubuFieldsFragmentDoc}`;
export const UserLazbubuInfoDocument = gql`
    query userLazbubuInfo {
  giftLazbubuData
  lazbubuData
  giftLazbubuCreated
  lazbubuCreated
}
    `;
export const LazbubuDataDocument = gql`
    query lazbubuData($activationCode: String) {
  lazbubuData(activationCode: $activationCode)
}
    `;
export const LazbubuListDocument = gql`
    query lazbubuList {
  lazbubuList {
    ...LazbubuFields
  }
}
    ${LazbubuFieldsFragmentDoc}`;
export const LostLazbubuListDocument = gql`
    query lostLazbubuList {
  lostLazbubuList {
    ...LazbubuFields
  }
}
    ${LazbubuFieldsFragmentDoc}`;
export const GetLazbubuListDocument = gql`
    query getLazbubuList {
  lazbubuList {
    ...LazbubuFields
  }
  lostLazbubuList {
    ...LazbubuFields
  }
}
    ${LazbubuFieldsFragmentDoc}`;
export const MaxUsdAssetDocument = gql`
    query maxUsdAsset {
  maxUsdAsset {
    id
    community_id
    name
    logo_url
    usd_value
  }
}
    `;
export const MemoriesDocument = gql`
    query memories($tokenId: Int!, $pageNum: Int, $pageSize: Int) {
  memories(tokenId: $tokenId, pageNum: $pageNum, pageSize: $pageSize) {
    id
    tokenId
    content
    timestamp
  }
}
    `;
export const MemoryAvailableDocument = gql`
    query memoryAvailable($tokenId: Int!) {
  memoryAvailable(tokenId: $tokenId)
}
    `;
export const MessageQuotaDocument = gql`
    query messageQuota($tokenId: Int!) {
  messageQuota(tokenId: $tokenId) {
    claimed
    availableQuota
    dailyMessageQuota
    giftboxMessageQuota
    totalMessageQuota
    resetTime
    todayMessageCount
  }
}
    `;
export const MintPermitDocument = gql`
    query mintPermit {
  mintPermit {
    permit
    data
    err
  }
}
    `;
export const PersonalityAvailableDocument = gql`
    query personalityAvailable($tokenId: Int!) {
  personalityAvailable(tokenId: $tokenId)
}
    `;
export const ProofDocument = gql`
    mutation proof($proofRequest: String!) {
  proof(proofRequest: $proofRequest)
}
    `;
export const ReedemAcitvationCodeDocument = gql`
    mutation reedemAcitvationCode($activationCode: String!) {
  reedemAcitvationCode(activationCode: $activationCode)
}
    `;
export const SetLevelPermitDocument = gql`
    query setLevelPermit($tokenId: Int!) {
  setLevelPermit(tokenId: $tokenId) {
    permit
    data
    err
  }
}
    `;
export const SetPersonalityPermitDocument = gql`
    query setPersonalityPermit($tokenId: Int!) {
  setPersonalityPermit(tokenId: $tokenId) {
    permit
    data
    err
  }
}
    `;
export const SyncLevelDocument = gql`
    mutation syncLevel($tokenId: Int!) {
  syncLevel(tokenId: $tokenId)
}
    `;
export const UploadFileDocument = gql`
    mutation uploadFile($data: String!) {
  uploadFile(data: $data)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    adventurePermit(variables: AdventurePermitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdventurePermitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdventurePermitQuery>({ document: AdventurePermitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'adventurePermit', 'query', variables);
    },
    adventures(variables: AdventuresQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdventuresQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdventuresQuery>({ document: AdventuresDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'adventures', 'query', variables);
    },
    airdropInfo(variables?: AirdropInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AirdropInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AirdropInfoQuery>({ document: AirdropInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'airdropInfo', 'query', variables);
    },
    chat(variables: ChatMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChatMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChatMutation>({ document: ChatDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'chat', 'mutation', variables);
    },
    chats(variables: ChatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChatsQuery>({ document: ChatsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'chats', 'query', variables);
    },
    config(variables?: ConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfigQuery>({ document: ConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'config', 'query', variables);
    },
    countTodayAirdrop(variables?: CountTodayAirdropQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CountTodayAirdropQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountTodayAirdropQuery>({ document: CountTodayAirdropDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'countTodayAirdrop', 'query', variables);
    },
    setNames(variables: SetNamesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetNamesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetNamesMutation>({ document: SetNamesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'setNames', 'mutation', variables);
    },
    createMemoryPermit(variables: CreateMemoryPermitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateMemoryPermitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMemoryPermitQuery>({ document: CreateMemoryPermitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createMemoryPermit', 'query', variables);
    },
    generateChatImage(variables?: GenerateChatImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateChatImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateChatImageMutation>({ document: GenerateChatImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'generateChatImage', 'mutation', variables);
    },
    getChatsByShareId(variables: GetChatsByShareIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetChatsByShareIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetChatsByShareIdQuery>({ document: GetChatsByShareIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getChatsByShareId', 'query', variables);
    },
    getUserActivationCodes(variables?: GetUserActivationCodesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUserActivationCodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserActivationCodesQuery>({ document: GetUserActivationCodesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getUserActivationCodes', 'query', variables);
    },
    lazbubu(variables: LazbubuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LazbubuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LazbubuQuery>({ document: LazbubuDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'lazbubu', 'query', variables);
    },
    userLazbubuInfo(variables?: UserLazbubuInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserLazbubuInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserLazbubuInfoQuery>({ document: UserLazbubuInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userLazbubuInfo', 'query', variables);
    },
    lazbubuData(variables?: LazbubuDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LazbubuDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LazbubuDataQuery>({ document: LazbubuDataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'lazbubuData', 'query', variables);
    },
    lazbubuList(variables?: LazbubuListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LazbubuListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LazbubuListQuery>({ document: LazbubuListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'lazbubuList', 'query', variables);
    },
    lostLazbubuList(variables?: LostLazbubuListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LostLazbubuListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LostLazbubuListQuery>({ document: LostLazbubuListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'lostLazbubuList', 'query', variables);
    },
    getLazbubuList(variables?: GetLazbubuListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetLazbubuListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLazbubuListQuery>({ document: GetLazbubuListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getLazbubuList', 'query', variables);
    },
    maxUsdAsset(variables?: MaxUsdAssetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MaxUsdAssetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MaxUsdAssetQuery>({ document: MaxUsdAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'maxUsdAsset', 'query', variables);
    },
    memories(variables: MemoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MemoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MemoriesQuery>({ document: MemoriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'memories', 'query', variables);
    },
    memoryAvailable(variables: MemoryAvailableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MemoryAvailableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MemoryAvailableQuery>({ document: MemoryAvailableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'memoryAvailable', 'query', variables);
    },
    messageQuota(variables: MessageQuotaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MessageQuotaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MessageQuotaQuery>({ document: MessageQuotaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'messageQuota', 'query', variables);
    },
    mintPermit(variables?: MintPermitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MintPermitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MintPermitQuery>({ document: MintPermitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'mintPermit', 'query', variables);
    },
    personalityAvailable(variables: PersonalityAvailableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PersonalityAvailableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PersonalityAvailableQuery>({ document: PersonalityAvailableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'personalityAvailable', 'query', variables);
    },
    proof(variables: ProofMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProofMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProofMutation>({ document: ProofDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'proof', 'mutation', variables);
    },
    reedemAcitvationCode(variables: ReedemAcitvationCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReedemAcitvationCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReedemAcitvationCodeMutation>({ document: ReedemAcitvationCodeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reedemAcitvationCode', 'mutation', variables);
    },
    setLevelPermit(variables: SetLevelPermitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetLevelPermitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLevelPermitQuery>({ document: SetLevelPermitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'setLevelPermit', 'query', variables);
    },
    setPersonalityPermit(variables: SetPersonalityPermitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetPersonalityPermitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetPersonalityPermitQuery>({ document: SetPersonalityPermitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'setPersonalityPermit', 'query', variables);
    },
    syncLevel(variables: SyncLevelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SyncLevelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncLevelMutation>({ document: SyncLevelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'syncLevel', 'mutation', variables);
    },
    uploadFile(variables: UploadFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UploadFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadFileMutation>({ document: UploadFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'uploadFile', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;